module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-button-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-0afbc731"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/button/src/button-group.vue
// module id = 232
// module chunks = 0